import { gql } from '@apollo/client';

export const GET_CREW_MEMBER_GROUPS = gql`
	query crewMemberGroups {
		crewMemberGroups {
			id
			name
			description
			createdBy
			membersCount
		}
	}
`;
